import {  Unsubscribe } from "firebase/firestore";
import { Report } from "../model/Report";

import * as firestoreClient from '../script/firestore-client'

const table = 'report'

export function save(id: string) {
  firestoreClient.save(table, {id: id}, [id])
}

export async function update(report: Report) {
  firestoreClient.update(table, [report.id], report)
}

export async function findFromCache(id: string): Promise<Report> {
  return await firestoreClient.findFromCache(table, [id]) as Report
}

export function watch(
  id: string,
  cb: (r: Report) => void
): Unsubscribe {
  return firestoreClient.watch(table, [id], data => {
    cb(data as Report)
  })
}